import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDebouncedAction } from "../../../../../../helpers/commonFunction";
import { AppState } from "../../../../../../stateManager/store";
import { getValue, getComponents } from "../../helpers";

import { onChange } from "./helpers/on-change"
import { FormCreationData } from "../../../../../../stateManager/store/formCreation_v2/types";

const DEFAULT_BORDER_FONT_SIZE: string = "properties.styles.common.fontSize";
const DEFAULT_BORDER_FONT_SIZE_v3: string = "properties.styles.$deviceType.fontSize";

type Props = {
  label: string;
  isCheckedIn: boolean;
  defaultValue?: string;
}

const excluded_types = [
  "ExpansionPanel",
  "Row",
  "Column",
  "Grid",
  "RichtextEditor",
  "Select",
  "IconButton",
  "Lottie",
  "Avatar",
  "Icon",
  "ImageSlider",
  "ImageViewer",
  "PdfViewer",
  "Divider",
  "Spacer",
  "Table",
  "Fab",
  "Stepper",
  "Autocomplete",
  "CustomModal",
  "ExpansionPanel",
  "Modal",
  "SnackBar",
  "html",
  "Markdown",
  "oAuth",
  "QRCode",
  "Rating",
  "Scanner",
  "SegmentControl",
  "Selfie",
  "SignaturePad",
  "Stats",
  "StatsNumber",
  "TabBar",
  "Upload",
  "Description"
]

export const FontSize = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType, computedStyles, wrapperComputedStyles, isCoreV3 } = useSelector((state: AppState) => state.formJson)
  const { isCheckedIn, defaultValue, label } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useDebouncedAction(defaultValue, 500 || "");
  const component: FormCreationData = components[selectedElementId];
  const { type } = component;

  const calculateHeight = () => {
    const deviceHeight = getValue(
      component,
      ["properties", "styles", deviceType, "height"],
      deviceType
    )
    if (deviceHeight === undefined) {
      const wrapperStyles = wrapperComputedStyles.hasOwnProperty("height") ? wrapperComputedStyles : computedStyles;
      const height = (wrapperStyles && wrapperStyles.height && wrapperStyles.height.match(/\d+/) ? wrapperStyles.height.match(/\d+/)[0] : null);
      return height;
    }
    return deviceHeight
  }

  useEffect(() => {
    // core v3
    if (isCoreV3 && component) {
      const deviceFontSize = getValue(component, DEFAULT_BORDER_FONT_SIZE_v3.split("."), deviceType);
      if (!deviceFontSize) {
        const wrapperStyles = wrapperComputedStyles.hasOwnProperty("fontSize") ? wrapperComputedStyles : computedStyles;
        const fontSize = (wrapperStyles && wrapperStyles.fontSize && wrapperStyles.fontSize.match(/\d+/) ? wrapperStyles.fontSize.match(/\d+/)[0] : null);
        setValue(fontSize);
        setOldValue(fontSize);
      } else {
        setValue(deviceFontSize);
        setOldValue(deviceFontSize);
      }
    }
    // core v2 
    else if (!isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_BORDER_FONT_SIZE.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue);
        setOldValue(previousValue);
      }
    }
    // eslint-disable-next-line
  }, [isCoreV3, component, deviceType, computedStyles]);

  if (isCoreV3 && excluded_types.includes(type)) {
    return null;
  }

  return (
    <div className="panel-div">
      <label
        htmlFor="horizontal"
        className="panel-label"
      >
        {label}
      </label>
      <input
        style={{ cursor: !isCheckedIn ? "not-allowed" : "auto" }}
        disabled={!isCheckedIn}
        type="number"
        id="fontsize"
        min="0"
        value={value}
        className="panel-input"
        placeholder="0"
        onChange={e => {
          const changeValue = e.target.value;
          const value = changeValue ? Number(changeValue) > 0 ? changeValue: "0": changeValue;
          setValue(value, () => onChange({
            path: isCoreV3 ? DEFAULT_BORDER_FONT_SIZE_v3 : DEFAULT_BORDER_FONT_SIZE,
            value,
            oldValue,
            setOldValue,
            selectedElementId
          }))
        }}
      />
    </div>
  )
};